// Ranking actions
export const GET_RANKINGS = 'GET_RANKINGS';
export const GET_RANKING = 'GET_RANKING';
export const GET_RANKING_TESTS = 'GET_RANKING_TESTS';
export const GET_RANKING_TEST = 'GET_RANKING_TEST';
export const GET_RANKING_TEST_RESULTS = 'GET_RANKING_TEST_RESULTS';

// User actions
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_PROFILE = 'GET_PROFILE'
export const NO_USER = 'NO_USER'

// Rider actions
export const GET_RIDER = 'GET_RIDER'
export const GET_RIDER_RESULTS = 'GET_RIDER_RESULTS'
